import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import AppDownloadCTA from './components/AppDownloadCTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotArticles />
        <AppDownloadCTA />
      </main>
      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: '52吃瓜网',
                url: 'http://bi365.cn/',
                description:
                  '52吃瓜网首页聚合最新吃瓜爆料、网红黑料、明星塌房事件，提供52吃瓜网官网入口、app下载及最新消息，每日实时更新热门大瓜。',
                sameAs: ['http://bi365.cn/'],
                contactPoint: {
                  '@type': 'ContactPoint',
                  email: 'hello@bi365.cn',
                  contactType: '爆料投稿',
                },
              },
              {
                '@type': 'WebSite',
                name: '52吃瓜网',
                url: 'http://bi365.cn/',
                description:
                  '52吃瓜网首页聚合最新吃瓜爆料、网红黑料、明星塌房事件，提供52吃瓜网官网入口、app下载及最新消息，每日实时更新热门大瓜。',
                inLanguage: 'zh-Hans',
              },
              {
                '@type': 'WebPage',
                name: '52吃瓜网 - 首页',
                url: 'http://bi365.cn/',
                description:
                  '52吃瓜网首页聚合最新吃瓜爆料、网红黑料、明星塌房事件，提供52吃瓜网官网入口、app下载及最新消息，每日实时更新热门大瓜。',
                isPartOf: { '@id': 'http://bi365.cn/#website' },
              },
            ],
          }),
        }}
      />
    </>
  );
}